import type { RepeaterInputRef, RepeaterProps, RowElProps } from '@/Components/inputs/Repeater';
import Repeater from '@/Components/inputs/Repeater';
import { Stack, TextField } from '@mui/material';
import type React from 'react';
import { forwardRef, useEffect, useRef, useState } from 'react';
import IconAutocomplete, { faParseIconName } from '../IconAutocomplete';

const initSocialLinksState = Object.freeze({
  name: '' as string,
  url: 'https://' as string,
});

export type SocialLinksState = typeof initSocialLinksState;

const SocialLinksRow = ({ index, onStateChange, initState, disabled = false }: RowElProps<SocialLinksState>) => {
  const [state, setState] = useState(
    initState || {
      ...initSocialLinksState,
    }
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setState((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    onStateChange(index, state);
  }, [state]);

  return (
    <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1} sx={{ width: '100%' }}>
      <IconAutocomplete
        disabled={disabled}
        style={{ width: '20%' }}
        value={faParseIconName(state?.name, 'fab')}
        onChange={(icon) => {
          setState((prev) => ({ ...prev, name: icon ?? '' }));
        }}
        disablePortal
      />
      <div style={{ width: '80%' }}>
        <TextField
          disabled={disabled}
          name="url"
          label="Url"
          placeholder="Button Url"
          size="small"
          fullWidth
          value={state?.url}
          onChange={handleChange}
        />
      </div>
      <div />
    </Stack>
  );
};

export const useSocialLinksRepeaterRef = () => {
  return useRef<RepeaterInputRef<SocialLinksState>>(null);
};

type SocialLinksRepeaterProps = Omit<RepeaterProps<SocialLinksState>, 'rowEl'>;

const SocialLinksRepeater = (
  props: SocialLinksRepeaterProps,
  ref: React.ForwardedRef<RepeaterInputRef<SocialLinksState>>
) => {
  return <Repeater rowEl={SocialLinksRow} {...props} ref={ref} />;
};
const forwardRepeater = forwardRef(SocialLinksRepeater);

export { forwardRepeater as SocialLinksRepeater };
export default forwardRepeater;
